export default __webpack_public_path__ + "proximanova-boldit-webfont.woff2";